// extracted by mini-css-extract-plugin
module.exports = {"container":"Popover_container__NQXX2","button":"Popover_button__2-sFU","popover":"Popover_popover__36bzg","fadein":"Popover_fadein__3dl8w","layover":"Popover_layover__3I2PX"};